import styled from 'styled-components'

import { color } from '~/styles/variables'

export const Wrap = styled.span`
  display: block;
  margin: 10px 0;

  label{
    display: inline-flex;
    font-weight: 400;
    cursor: pointer;
    align-items: center;
    margin: 0;
    padding: 10px 0;
    position: relative;

    span{
      &:last-child{
        padding-left: 10px;
      }
    }

    .circle-check{
      width: 20px;
      height: 20px;
      border: 2px solid #707070;
      color: #707070;
      border-radius: 50%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      
      &:before{
        font-weight: 700;
        color: inherit;
        line-height: 1;
        font-size: 13px;
      }
    }

    input:checked + .circle-check {
      background: ${color.fith};
      border-color: ${color.fith};

      &:before{
        color: #FFFFFF;
      }
    }

    input{
      display: none;
    }

    &:hover{
     color: ${color.fith};

     .circle-check{
      border-color: ${color.fith};
      color: ${color.fith};
     }
    }
  }
`